import {
  FETCH_LIMITED_SERVICE_AVAILABILITY_FAILURE, 
  FETCH_LIMITED_SERVICE_AVAILABILITY_REQUEST, 
  FETCH_LIMITED_SERVICE_AVAILABILITY_SUCCESS
} from "../actions/limitedServiceAvailability/types";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export default function limitedServiceAvailabilityReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_LIMITED_SERVICE_AVAILABILITY_REQUEST:
      return { ...state, loading: true };
    case FETCH_LIMITED_SERVICE_AVAILABILITY_SUCCESS:
      return { 
        ...state, 
        data: action.data?.filter((limitedServices) => limitedServices.isActive), 
        loading: false
      };
    case FETCH_LIMITED_SERVICE_AVAILABILITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state;
  }
}